import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const LONG_RANGES_API_NAME: string = 'long_range';
export const LONG_RANGES_API_ENDPOINT: string = environment.API_BASE_PATH + '/long-range';

@Injectable({
  providedIn: 'root',
})
export class LongRangeService {
  list(): Observable<any> {
    const api_name: string = LONG_RANGES_API_NAME;
    const path: string = '';
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export interface LongRange {
  long_range_id?: string;
  object?: string;
  min_amount?: number;
  max_amount?: number;
  allowed_steps?: number[];
}
